

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_7ezdj6xz6m = () => {
                    
                        if (document.querySelector('.beae-qenji4y7:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-qenji4y7:not([data-beae-bind])'),
                                
                                id: 'beae-qenji4y7',
                                isLive: true
                            });
                            document.querySelector('.beae-qenji4y7:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-t42h6a5f:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-t42h6a5f:not([data-beae-bind])'),
                                
                                id: 'beae-t42h6a5f',
                                isLive: true
                            });
                            document.querySelector('.beae-t42h6a5f:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-8tiz8mpp:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-8tiz8mpp:not([data-beae-bind])'),
                                
                                id: 'beae-8tiz8mpp',
                                isLive: true
                            });
                            document.querySelector('.beae-8tiz8mpp:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-le69oxno:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-le69oxno:not([data-beae-bind])'),
                                
                                id: 'beae-le69oxno',
                                isLive: true
                            });
                            document.querySelector('.beae-le69oxno:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_7ezdj6xz6m()
                } else {
                    window.beaePageJS.push(jsHandle_7ezdj6xz6m)
                }
            